<div @fadeInUp class="submit-deal-container">
	<cds-select
		label="Select Fund"
		[(ngModel)]="currentDealName"
		(valueChange)="onDealSelected($event)"
	>
		<option *ngFor="let deal of userData['Deals']" [value]="deal['Deal Name']">{{deal['Deal Name']}}</option>
	</cds-select>

	<cds-button-set>
		<button size="xl" cdsButton="primary" (click)="submitDeal()">
			Compile Data
			<svg class="cds--btn__icon" cdsIcon="data-collection" size="16"></svg>
		</button>
	</cds-button-set>
</div>
